module.exports = __webpack_public_path__ + "media/stylesheets/font/summernote-bd0d8be1fbad3612dfe1e6baafd42af3.eot";